import React from 'react'
import { FormattedMessage } from 'react-intl'

import { PanelMonitorContent } from './PanelMonitorContent'
import { PanelMenuPopOver } from './PanelMenu/PanelMenuPopOver'

import './PanelMonitor.scss'

//
// PanelMonitor
//
// The panel monitor component is the interface for the host to operate with the
// select speaker panel feature and ultimately see the Stage UI reflect these
// changes.
//

interface PanelMonitorProps {
  isSelected: boolean
}

const PanelMonitor = ({ isSelected }: PanelMonitorProps) => {
  return (
    <div className="panel-monitor" data-selected={isSelected}>
      <PanelMonitorContent isSelected={isSelected} />

      <div className="panel-monitor-panel">
        <FormattedMessage defaultMessage="Panel Mix" />
      </div>

      <PanelMenuPopOver />
    </div>
  )
}

export { PanelMonitor }
